import type { ToolkitStore } from '@reduxjs/toolkit/src/configureStore';

import type { GatewayRanking } from 'commonTypes/api/gatewayRanking';
import { PARTNER_IDS_WITH_PREVIOUS_USER_DATA, USING_PROFILE_SERVICE_WL_IDS_WITH_JWE } from 'constants/partners';

import { creditFormSlice } from 'entities/creditForm';
import { whiteLabelSlice } from 'entities/whiteLabels';

export const setWLToStore = (ctx: App.ReduxAppContext['ctx'], reduxStore: ToolkitStore) => {
  if (ctx.req?.__WL__?.isWL) {
    const partnerId = ctx.req.__WL__?.partnerId;

    const isWLWithJWE =
      USING_PROFILE_SERVICE_WL_IDS_WITH_JWE.includes(
        // нужен каст чтобы проверить partnerId
        (partnerId as (typeof USING_PROFILE_SERVICE_WL_IDS_WITH_JWE)[number]) || 0,
      ) && !!ctx.req.headers.authorization;

    const isWLWithPreviousUserData =
      PARTNER_IDS_WITH_PREVIOUS_USER_DATA.includes(
        // нужен каст чтобы проверить partnerId
        (partnerId as (typeof PARTNER_IDS_WITH_PREVIOUS_USER_DATA)[number]) || 0,
      ) || isWLWithJWE;

    const rawBlockFF = (ctx.req.__WL__.blockFF ?? {}) as Partial<GatewayRanking.RankingFeatureFlagsConfig>;

    const { preSelectedPeriod, preSelectedAmount, isCreditCardsForm, ...blockFF } = rawBlockFF;

    reduxStore.dispatch(
      whiteLabelSlice.actions.setWhiteLabel({
        wl: ctx.req.__WL__.analytics,
        nonPartnerWl: !!ctx.req.__WL__.nonPartnerWl,
        isFullLanding: ctx.req.__WL__.isFullLanding,
        isWL: true,
        isWLWithPreviousUserData,
        isWLWithJWE,
        isWLWithShortFooter: true,
        blockFF,
        isServerFormValid: ctx.req?.__IS_SERVER_FORM_VALID__ || false,
      }),
    );

    reduxStore.dispatch(
      creditFormSlice.actions.setFormBlockFF({
        preSelectedPeriod,
        preSelectedAmount,
        preSelectedPurpose: blockFF.preSelectedPurpose,
        withoutAdditionalFilters: blockFF.withoutAdditionalFilters,
        isCreditCardsForm,
      }),
    );
  }
};
